module.exports = __webpack_public_path__ + "static/img/SG@3x.62b29801.jpg";